import { useEffect } from 'react';
import { Card, Row, Col, Statistic } from 'antd';
import { UserOutlined, ShoppingCartOutlined, TeamOutlined, DollarOutlined } from '@ant-design/icons';
import AdminSidebar from '../Components/Sidebar';
import { useDispatch, useSelector } from 'react-redux';
import { getDashboardData } from '../redux/slices/adminSlice';

function Dashboard() {
    const dispatch = useDispatch();
    const { dashboardData } = useSelector((state) => state?.admin)

    useEffect(() => {
        dispatch(getDashboardData())
    }, [dispatch]);

    // Calculate totals
    const totalUsers = dashboardData?.data?.totalUsers || 0;
    const totalProviders = dashboardData?.data?.totalProviders || 0;
    const totalAppointments = dashboardData?.data?.totalAppointments || 0;
    const totalTransactions = dashboardData?.data?.totalTransactionsSum || 0;

    return (
        <>
            <AdminSidebar renderContent={
                <>

                    <Card
                        title="Dashboard"
                        style={{ marginBottom: 24 }}
                    >
                        <Row gutter={[16, 16]} style={{ marginBottom: 24 }}>
                            {/* Total Users Card */}
                            <Col xs={24} sm={8}>
                                <Card
                                    style={{
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        border: 'none',
                                    }}
                                >
                                    <Statistic
                                        title={<span style={{ fontSize: '16px', fontWeight: 500 }}>Total Users</span>}
                                        value={totalUsers}
                                        prefix={<UserOutlined style={{ color: '#CA9AE8', fontSize: '28px' }} />}
                                        valueStyle={{ color: '#CA9AE8', fontSize: '32px', fontWeight: 'bold' }}
                                    />
                                </Card>
                            </Col>

                            {/* Total Providers Card */}
                            <Col xs={24} sm={8}>
                                <Card
                                    style={{
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        border: 'none',
                                    }}
                                >
                                    <Statistic
                                        title={<span style={{ fontSize: '16px', fontWeight: 500 }}>Total Providers</span>}
                                        value={totalProviders}
                                        prefix={<TeamOutlined style={{ color: '#CA9AE8', fontSize: '28px' }} />}
                                        valueStyle={{ color: '#CA9AE8', fontSize: '32px', fontWeight: 'bold' }}
                                    />
                                </Card>
                            </Col>

                            {/* Total Orders Card */}
                            <Col xs={24} sm={8}>
                                <Card
                                    style={{
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        border: 'none',
                                    }}
                                >
                                    <Statistic
                                        title={<span style={{ fontSize: '16px', fontWeight: 500 }}>Total Appointments</span>}
                                        value={totalAppointments}
                                        prefix={<ShoppingCartOutlined style={{ color: '#CA9AE8', fontSize: '28px' }} />}
                                        valueStyle={{ color: '#CA9AE8', fontSize: '32px', fontWeight: 'bold' }}
                                    />
                                </Card>
                            </Col>

                            <Col xs={24} sm={8}>
                                <Card
                                    style={{
                                        borderRadius: '12px',
                                        boxShadow: '0 2px 8px rgba(0, 0, 0, 0.1)',
                                        border: 'none',
                                    }}
                                >
                                    <Statistic
                                        title={<span style={{ fontSize: '16px', fontWeight: 500 }}>Total Transactions</span>}
                                        value={totalTransactions}
                                        prefix={<DollarOutlined style={{ color: '#CA9AE8', fontSize: '28px' }} />}
                                        valueStyle={{ color: '#CA9AE8', fontSize: '32px', fontWeight: 'bold' }}
                                    />
                                </Card>
                            </Col>
                        </Row>

                    </Card>
                </>
            } />
        </>
    );
}

export default Dashboard;